import React from 'react';

const REASONS = [
  { key: 'reason1', reveal: 'scroll-reveal-left' },
  { key: 'reason2', reveal: 'scroll-reveal-right' },
  { key: 'reason3', reveal: 'scroll-reveal-left' },
  { key: 'reason4', reveal: 'scroll-reveal-right' },
];

const WhyUsSection = ({ t }) => (
  <section className="py-12 bg-gray-50 curtain-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16 scroll-reveal">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          {t.whyUs.title} <span className="text-gradient">{t.whyUs.titleHighlight}</span>
          {t.whyUs.titleEnd}
        </h2>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto">{t.whyUs.subtitle}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 stagger-list">
        {REASONS.map(({ key, reveal }) => {
          const r = t.whyUs[key];
          return (
            <div key={key} className={`bg-white p-8 rounded-xl shadow-md ${reveal} enhanced-card hover-lift`}>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{r.title}</h3>
              <p className="text-gray-600 leading-relaxed">{r.description}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default WhyUsSection;
